import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionHead from "./ui/SectionHead";
import { ArrowUpRight, GooglePlay } from "./ui/Icons";
import offlineMobileAppImg from "../image/OfflineMobileApp.png";

const SPECS = ["offline", "android", "free"];

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.agrihyphenai.app&pcampaignid=web_share";

export default function MobileApp() {
  const { t } = useTranslation();

  return (
    <section id="mobile-app" className="scroll-mt-24 section bg-agri-paperDeep">
      <div className="container-x">
        <SectionHead
          kicker={t("design.mobile.badge")}
          title={t("design.mobile.title")}
        >
          {t("design.mobile.desc")}
        </SectionHead>

        <div className="grid grid-cols-1 items-center gap-x-14 gap-y-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <dl>
              {SPECS.map((key, i) => (
                <div
                  key={key}
                  className="grid grid-cols-[3rem_1fr] gap-x-4 border-t border-agri-rule py-6 first:border-t-0 first:pt-0 sm:grid-cols-[4rem_1fr] sm:gap-x-6 sm:py-7"
                >
                  <span className="pt-1 font-mono text-xs font-medium tabular-nums text-agri-clay">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <dt className="font-display text-[1.1875rem] font-semibold leading-snug tracking-[-0.015em] text-agri-ink sm:text-[1.3125rem]">
                      {t(`design.mobile.specs.${key}`)}
                    </dt>
                    <dd className="mt-2 max-w-measure text-[0.9375rem] leading-[1.7] text-agri-ink80">
                      {t(`design.mobile.specs.${key}Desc`)}
                    </dd>
                  </div>
                </div>
              ))}
            </dl>

            <div className="mt-10 border-t border-agri-rule pt-6">
              <p className="kicker">{t("design.mobile.statusLabel")}</p>
              <div className="mt-3 flex items-center gap-2.5 text-[0.9375rem] font-medium text-agri-ink">
                <span className="relative flex h-2.5 w-2.5 shrink-0">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-600" />
                </span>
                <span>{t("design.mobile.status")}</span>
              </div>

              <div className="mt-7 flex flex-wrap items-center gap-3">
                <a
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                >
                  <GooglePlay className="h-4 w-4" />
                  <span>{t("design.mobile.download")}</span>
                  <ArrowUpRight className="h-3.5 w-3.5 opacity-70" />
                </a>
                <Link to="/test-ai" className="btn-outline">
                  {t("design.mobile.useWeb")}
                </Link>
              </div>
            </div>
          </div>

          <div className="flex justify-center lg:col-span-5 lg:justify-end">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download AgriHyphen AI on Google Play"
              className="group relative block w-full max-w-[22rem] sm:max-w-[26rem] lg:max-w-none transition-transform duration-300 hover:scale-[1.02]"
            >
              <img
                src={offlineMobileAppImg}
                alt="AgriHyphen AI Mobile App preview"
                loading="lazy"
                className="mx-auto h-auto w-full object-contain drop-shadow-2xl"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

